import zmFormula from "./zmFormulaHelperService";
import util from "zmfront-framework/src/utils/util";
import zmRemoteFee from "./zmQueryRemoteFeeService";
import zmPackingFee from "./zmPackingFeeService";
import http from "zmfront-framework/src/utils/httpservice";
const zmPremiumFee = {};
//
zmPremiumFee.facade={};
//超值费查询
zmPremiumFee.param={};
zmPremiumFee.bo={};
const getCacheRefresh = function (str) {
    return new Promise((resolve,reject) => {
        if(str){
            //打开日期缓存 不存在就重新缓存
            if(str=="strDate"){
                let strDate =  util.get("strDate");
                if(strDate){
                    resolve(strDate);
                }else{
                    let newDate=new Date();
                    let detas = newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
                    util.set("strDate",detas);
                    resolve(detas);
                }
            }
            if(str=="remotefeUrl"){ //获取偏远费
                let remotefeUrl = util.get("remotefeUrl");
                if(remotefeUrl){
                    resolve(remotefeUrl);
                }else{
                    http.get('bms/quoteremotefee/url/find', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("remotefeUrl", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
            if(str=="remotefe"){
                let remotefe = util.get("remotefe");
                if(remotefe){
                    resolve(remotefe);
                }else{
                    http.get('bms/quoteremotefee/front/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("remotefe", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
            if(str=="quotefuel"){
                let quotefuel = util.get("quotefuel");
                if(quotefuel){
                    resolve(quotefuel)
                }else{
                    http.get('bms/quotefuel/transfer/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("quotefuel", res);
                            resolve(res)
                        }
                    }).catch(res => {
                    });
                }
            }
            if(str=="packing"){
                let packing = util.get("packing");
                if(packing){
                    resolve(packing);
                }else{
                    http.get('bms/quotepackingfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("packing", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
            if(str=="packingOpt"){
                let packingOpt = util.get("packingOpt");
                if(packingOpt){
                    resolve(packingOpt);
                }else{
                    http.get('bms/quotepackingfee/opt/using/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("packingOpt", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
            if(str=="quotepremiumfee"){
                let quotepremiumfee = util.get("quotepremiumfee");
                if(quotepremiumfee){
                    resolve(quotepremiumfee);
                }else{
                    http.get('bms/quotepremiumfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                        if (res) {
                            util.set("quotepremiumfee", res);
                            resolve(res);
                        }
                    }).catch(res => {
                    });
                }
            }
        }
    });

}
const getResult=async function (param){
    await dateFeeCaChe();
    zmFormula.zmformulahelper(param.formula);
    zmFormula.setParam("@s",zmPremiumFee.param.declarePrice);
    //返回执行值
    return parseFloat(zmFormula.evalOfBigDecimal());
};
const dateFeeCaChe=async function (){
    var strs= await getCacheRefresh("strDate");
    var sdate = strs.split('-');
    var date1 = new Date(sdate[0], sdate[1]-1, sdate[2]);

    let strDate=new Date();
    var jshu=strDate.getFullYear() + '-' + (strDate.getMonth() + 1) + '-' + strDate.getDate();
    var str=jshu.split('-');
    var dec = new Date(str[0], str[1]-1, str[2]);
    if(date1.getTime()<dec.getTime()) {
        await loginQuoteRemotefee();
        await loginQuoteRemotefeeUrl();
        await loginQuotepremiumfee();
        await loginPackingOpt();
        await loginPackingFee();
        await loginQuotefuel();
        util.remove("strDate");
        util.set("strDate",jshu);
    }
};
//获取偏远费验证路由
const loginQuoteRemotefeeUrl= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("remotefeUrl")) {
            http.get('bms/quoteremotefee/url/find', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefeUrl", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("remotefeUrl");
            http.get('bms/quoteremotefee/url/find', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefeUrl", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    })
};
//获取偏远费
const loginQuoteRemotefee= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("remotefe")) {
            http.get('bms/quoteremotefee/front/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefe", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("remotefe");
            http.get('bms/quoteremotefee/front/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("remotefe", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });

};
//获取燃油信息
const loginQuotefuel= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("quotefuel")) {
            http.get('bms/quotefuel/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotefuel", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("quotefuel");
            http.get('bms/quotefuel/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotefuel", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });

};
//获取包装费规则
const loginPackingFee= function () {
    return new Promise((resolve,reject) => {
        if (!util.get("packing")) {
            http.get('bms/quotepackingfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packing", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("packing");
            http.get('bms/quotepackingfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packing", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });

};
//获取包装费明细
const loginPackingOpt= function (){
    return new Promise((resolve,reject) => {
        if (!util.get("packingOpt")) {
            http.get('bms/quotepackingfee/opt/using/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packingOpt", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("packingOpt");
            http.get('bms/quotepackingfee/opt/using/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("packingOpt", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });
};
//获取超值费用查询
const loginQuotepremiumfee= function (){
    return new Promise((resolve,reject) => {
        if (!util.get("quotepremiumfee")) {
            http.get('bms/quotepremiumfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotepremiumfee", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        } else {
            util.remove("quotepremiumfee");
            http.get('bms/quotepremiumfee/transfer/list', {}, {isShowMessage: 1}).then(res => {
                if (res) {
                    util.set("quotepremiumfee", res);
                    resolve("true");
                }
            }).catch(res => {
            });
        }
    });
};

//超值费用计算
zmPremiumFee.call= async function (param){
    zmPremiumFee.param=param;
    // let premiumfeeData=zmPackingFee2.getCacheRefresh("quotepremiumfee");
    let premiumfeeData= await getCacheRefresh("quotepremiumfee")
    let premiumfeeList=premiumfeeData.list;
    //1.获取缓存
    if(premiumfeeList==null || premiumfeeList.length<1){
        zmPremiumFee.bo.fee=0;
        zmPremiumFee.bo.formula='';
        zmPremiumFee.bo.currency=param.currency;
    }else{
        //判断符合的数据
        let premiumfee=[];
        //2.锁定数据
        for(var i=0;i<premiumfeeList.length;i++){
            if(premiumfeeList[i].hubId==param.hubId && param.declarePrice>= premiumfeeList[i].minDeclarePrice
                && param.declarePrice <= premiumfeeList[i].maxDeclarePrice && premiumfeeList[i].declareCurrency==param.currency){
                premiumfee.push(premiumfeeList[i]);
            }
        }
        if(premiumfee==null || premiumfee.length<1){
            zmPremiumFee.bo.fee=0;
            zmPremiumFee.bo.formula='';
            zmPremiumFee.bo.currency=param.currency;
        }else{
            //取第一条数据
          let fee=await getResult(premiumfee[0]);
            zmPremiumFee.bo.formula=parseFloat(fee).toFixed(2);
            zmPremiumFee.bo.fee=parseFloat(fee).toFixed(2);
            zmPremiumFee.bo.currency=premiumfee[0].premiumfeeCurrency;
        }
    }
        console.log(zmPremiumFee.bo);
    return zmPremiumFee.bo;
};


export default zmPremiumFee;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmPremiumFeeService.js